import { useNavigate, useLocation } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import "./Home.scss";
// import TableDetails from "../../components/DataTable/TableDetails";
import TableDetails from "../../components/table/TableDetails";
import SearchInput from "../../components/search/SearchInput";
import DataTable from "../../components/DataTable/DataTable";
import ImageContainer from "../../components/imageContainer/ImageContainer";
import { click } from "@testing-library/user-event/dist/click";
import { useCustomSearchParams } from "../../components/hooks/useCustomSearchParams";
import { SEARCH_PARAMS } from "../../utils/SearchParams";
import { KEY_NAME } from "../../utils/KeyName";
import { AppContext } from "../../context/AppContext";
import { HomeDescription } from "../../utils/TextMessage";
import AxiosService from "../../utils/AxiosService";
import Loader from "../../components/Loader/Loader";
import { config } from "@fortawesome/fontawesome-svg-core";
import { useParams } from "react-router-dom";

const TABLE_CONFIG_FOR_FUNDER = [
  {
    display: "FUNDER NAME",
    tableDisplay: true,
    field: "funderName",
    sortKey: "funderName",
    dataType: "text",
    sortable: false,
    clickable: true,
    // "tableRank": 8,
    // "popupDisplay": true,
    // "popupType": "accepting",
    // "popupRank": 8,
    // "filterRank": 0,
    // "filterType": null,
    // "filterDisplay": false
  },
  {
    display: "TOTAL PUBLICATIONS",
    tableDisplay: true,
    field: "totalPublications",
    sortKey: "totalPublications",
    dataType: "number",
    sortable: false,
    clickable: false,
  },
  {
    display: "% INCREASE (since last month)",
    tableDisplay: true,
    field: "percentIncrease",
    sortKey: "percentIncrease",
    dataType: "percentage",
    sortable: false,
    clickable: false,
  },
];

const TABLE_DATA_FOR_FUNDER = [
  {
    agencyId: "100000199",
    funderName: "U.S. Department of Agriculture",
    shortName: "USDA",
    totalPublications: 61403,
    percentIncrease: 0.35,
  },
  {
    agencyId: "100000192",
    funderName: "National Oceanic and Atmospheric Administration",
    shortName: "NOAA",
    totalPublications: 13401,
    percentIncrease: 0.31,
  },
  {
    agencyId: "100000161",
    funderName: "National Institute of Standards and Technology",
    shortName: "NIST",
    totalPublications: 12882,
    percentIncrease: 0.42,
  },
  {
    agencyId: "100000001",
    funderName: "National Science Foundation",
    shortName: "NSF",
    totalPublications: 506879,
    percentIncrease: 0.28,
  },
  {
    agencyId: "100000015",
    funderName: "U.S. Department of Energy",
    shortName: "USDOE",
    totalPublications: 229076,
    percentIncrease: 0.4,
  },
  {
    agencyId: "100000005",
    funderName: "U.S. Department of Defense",
    shortName: "USDOD",
    totalPublications: 168701,
    percentIncrease: 0.39,
  },
  {
    agencyId: "100000203",
    funderName: "U.S. Geological Survey",
    shortName: "USGS",
    totalPublications: 7623,
    percentIncrease: 0.41,
  },
  {
    agencyId: "100011039",
    funderName: "Intelligence Advanced Research Projects Activity",
    shortName: "IARPA",
    totalPublications: 1573,
    percentIncrease: 0.13,
  },
  {
    agencyId: "100000104",
    funderName: "National Aeronautics and Space Administration",
    shortName: "NASA",
    totalPublications: 61607,
    percentIncrease: 0.49,
  },
  {
    agencyId: "100000014",
    funderName: "Smithsonian Institution",
    shortName: "Smithsonian",
    totalPublications: 2928,
    percentIncrease: 0.24,
  },
  {
    agencyId: "100000200",
    funderName: "USAID",
    shortName: "USAID",
    totalPublications: 8602,
    percentIncrease: 0.12,
  },
  {
    agencyId: "501100002241",
    funderName: "Japan Science and Technology Agency",
    shortName: "JST",
    totalPublications: 59322,
    percentIncrease: 0.48,
  },
  {
    agencyId: "100011038",
    funderName: "Office of the Department of National Intelligence",
    shortName: "ODNI",
    totalPublications: 2017,
    percentIncrease: 0.25,
  },
  {
    agencyId: "501100000943",
    funderName: "CSIRO",
    shortName: "CSIRO",
    totalPublications: 4505,
    percentIncrease: 0.47,
  },
];

const TABLE_CONFIG_FOR_PUBLISHER = [
  {
    display: "PUBLISHER NAME",
    tableDisplay: true,
    field: "publisherName",
    sortKey: "publisherName",
    dataType: "text",
    sortable: false,
    clickable: true,
  },
  {
    display: "TOTAL PUBLICATIONS",
    tableDisplay: true,
    field: "totalPublications",
    sortKey: "totalPublications",
    dataType: "number",
    sortable: false,
    clickable: false,
  },
  {
    display: "% INCREASE (since last month)",
    tableDisplay: true,
    field: "percentIncrease",
    sortKey: "percentIncrease",
    dataType: "percentage",
    sortable: false,
    clickable: false,
  },
];

const TABLE_DATA_FOR_PUBLISHER = [
  {
    memberId: "316",
    publisherName: "American Chemical Society (ACS)",
    shortName: "ACS",
    totalPublications: 606674,
    percentIncrease: 0.45,
  },
  {
    memberId: "301",
    publisherName: "Taylor & Francis",
    shortName: "IUKL",
    totalPublications: 326062,
    percentIncrease: 1.18,
  },
  {
    memberId: "285",
    publisherName: "Optica Publishing Group",
    shortName: "OPTICA",
    totalPublications: 90520,
    percentIncrease: 0.2,
  },
  {
    memberId: "179",
    publisherName: "SAGE Publications",
    shortName: "SAGE",
    totalPublications: 149772,
    percentIncrease: 0.64,
  },
  {
    memberId: "2208",
    publisherName: "American Astronomical Society (AAS)",
    shortName: "AAS",
    totalPublications: 18539,
    percentIncrease: 0.92,
  },
  {
    memberId: "13",
    publisherName: "American Geophysical Union (AGU)",
    shortName: "AGU",
    totalPublications: 57040,
    percentIncrease: 0.54,
  },
  {
    memberId: "341",
    publisherName: "Proceedings of the National Academy of Sciences (PNAS)",
    shortName: "PNAS",
    totalPublications: 30918,
    percentIncrease: 0.46,
  },
  {
    memberId: "33",
    publisherName: "American Society of Mechanical Engineers (ASME)",
    shortName: "ASME",
    totalPublications: 11367,
    percentIncrease: 0.57,
  },
  {
    memberId: "8410",
    publisherName: "OAE Publishing",
    shortName: "OAE",
    totalPublications: 546,
    percentIncrease: 0,
  },
  {
    memberId: "16",
    publisherName: "American Physical Society (APS)",
    shortName: "APS",
    totalPublications: 219593,
    percentIncrease: 0.34,
  },
  {
    memberId: "311",
    publisherName: "Wiley",
    shortName: "WB",
    totalPublications: 1120562,
    percentIncrease: 0.48,
  },
  {
    memberId: "186",
    publisherName: "Society of Exploration Geophysicists (SEG)",
    shortName: "SEG",
    totalPublications: 2058,
    percentIncrease: 0.1,
  },
  {
    memberId: "1387",
    publisherName: "American Institute of Aeronautics and Astronautics (AIAA)",
    shortName: "AIAA",
    totalPublications: 6141,
    percentIncrease: 1.1,
  },
  {
    memberId: "859",
    publisherName: "GeoScienceWorld ",
    shortName: "Geo",
    totalPublications: 2447,
    percentIncrease: 0,
  },
  {
    memberId: "1968",
    publisherName: "MDPI AG",
    shortName: "MDPI",
    totalPublications: 464306,
    percentIncrease: 0,
  },
  {
    memberId: "221",
    publisherName: "AAAS",
    shortName: "AAAS",
    totalPublications: 18497,
    percentIncrease: 0.88,
  },
  {
    memberId: "320",
    publisherName: "Association for Computing Machinery (ACM)",
    shortName: "ACM",
    totalPublications: 89709,
    percentIncrease: 0.1,
  },
  {
    memberId: "263",
    publisherName: "Institute of Electrical & Electronics Engineers (IEEE)",
    shortName: "IEEE",
    totalPublications: 754044,
    percentIncrease: 0.91,
  },
  {
    memberId: "1167",
    publisherName: "American Diabetes Association",
    shortName: "ADA",
    totalPublications: 4121,
    percentIncrease: 0.15,
  },
  {
    memberId: "14",
    publisherName: "American Mathematical Society (AMS)",
    shortName: "AMS",
    totalPublications: 5560,
    percentIncrease: 0.65,
  },
  {
    memberId: "3",
    publisherName: "American Association of Physics Teachers (AAPT)",
    shortName: "AAPT",
    totalPublications: 186,
    percentIncrease: 0,
  },
  {
    memberId: "351",
    publisherName: "Society for Industrial & Applied Mathematics (SIAM)",
    shortName: "SIAM",
    totalPublications: 12660,
    percentIncrease: 0.26,
  },
  {
    memberId: "237",
    publisherName: "The Company of Biologists",
    shortName: "COB",
    totalPublications: 13410,
    percentIncrease: 0.43,
  },
  {
    memberId: "1394",
    publisherName: "Journal of Orthopaedic & Sports Physical Therapy (JOSPT)",
    shortName: "JOSPT",
    totalPublications: 5,
    percentIncrease: 0,
  },
  {
    memberId: "189",
    publisherName: "SPIE",
    shortName: "SPIE",
    totalPublications: 2949,
    percentIncrease: 0.85,
  },
  {
    memberId: "2090",
    publisherName: "RTI Press",
    shortName: "RTI",
    totalPublications: 46,
    percentIncrease: 0,
  },
  {
    memberId: "317",
    publisherName: "AIP Publishing LLC",
    shortName: "AIPP",
    totalPublications: 137225,
    percentIncrease: 0.23,
  },
  {
    memberId: "15",
    publisherName: "American Psychological Association (APA)",
    shortName: "APA",
    totalPublications: 41206,
    percentIncrease: 0.19,
  },
  {
    memberId: "266",
    publisherName: "IOP Publishing",
    shortName: "IOPP",
    totalPublications: 113999,
    percentIncrease: 0.53,
  },
  {
    memberId: "12",
    publisherName: "American Meteorological Society",
    shortName: "AMSociety",
    totalPublications: 10680,
    percentIncrease: 0.38,
  },
  {
    memberId: "20",
    publisherName: "American Vacuum Society (AVS)",
    shortName: "AVS",
    totalPublications: 4219,
    percentIncrease: 0.48,
  },
  {
    memberId: "187",
    publisherName: "Society of Rheology (SOR)",
    shortName: "SOR",
    totalPublications: 541,
    percentIncrease: 0.19,
  },
  {
    memberId: "4285",
    publisherName: "American College of Physicians (ACP)",
    shortName: "ACP",
    totalPublications: 527,
    percentIncrease: 0,
  },
  {
    memberId: "276",
    publisherName: "Wolters Kluwer Health",
    shortName: "WOLTERSKLUWERHEALTH",
    totalPublications: 17861,
    percentIncrease: 0.43,
  },
  {
    memberId: "9296",
    publisherName: "IP Innovative",
    shortName: "IPI",
    totalPublications: 36,
    percentIncrease: 0,
  },
];

const TABLE_CONFIG_FOR_INSTITUTION = [
  {
    display: "INSTITUTION NAME",
    field: "institutionName",
    sortKey: "institutionName",
    dataType: "text",
    sortable: false,
    clickable: true,
    tableDisplay: true,
    children: null,
  },
  {
    display: "TOTAL INSTITUTIONS",
    field: "totalInstitutions",
    sortKey: "totalInstitutions",
    dataType: "number",
    sortable: false,
    clickable: false,
    tableDisplay: true,
    children: null,
  },
  {
    display: "% INCREASE (since last month)",
    field: "percentIncrease",
    sortKey: "percentIncrease",
    dataType: "percentage",
    sortable: false,
    clickable: false,
    tableDisplay: true,
    children: null,
  },
];

const TABLE_DATA_FOR_INSTITUTION = [
  {
    institutionId: "49231",
    institutionName: "University of Denver",
    shortName: "UDENVER",
    totalInstitutions: 3313,
    percentIncrease: 0,
  },
  {
    institutionId: "34271",
    institutionName: "CSIRO Institution",
    shortName: "CSIRO",
    totalInstitutions: 17592,
    percentIncrease: 0,
  },
  {
    institutionId: "82652",
    institutionName: "Chiba University",
    shortName: "CHIBA",
    totalInstitutions: 10228,
    percentIncrease: 0,
  },
  {
    institutionId: "86154",
    institutionName: "Iowa State University",
    shortName: "ISU",
    totalInstitutions: 22217,
    percentIncrease: 0,
  },
  {
    institutionId: "42935",
    institutionName:
      "Japan International Research Center for Agricultural Sciences",
    shortName: "JIRCAS",
    totalInstitutions: 616,
    percentIncrease: 0,
  },
  {
    institutionId: "94281",
    institutionName: "National Institute for Environmental Studies of Japan",
    shortName: "NIES",
    totalInstitutions: 3518,
    percentIncrease: 0,
  },
  {
    institutionId: "76830",
    institutionName: "National Institute for Materials Science",
    shortName: "NIMS",
    totalInstitutions: 13027,
    percentIncrease: 0,
  },
  {
    institutionId: "38442",
    institutionName:
      "National Research Institute for Earth Science and Disaster Resilience",
    shortName: "NIED",
    totalInstitutions: 388,
    percentIncrease: 0,
  },
  {
    institutionId: "42108",
    institutionName: "RIKEN",
    shortName: "RIKEN",
    totalInstitutions: 22746,
    percentIncrease: 0,
  },
  {
    institutionId: "84283",
    institutionName: "The University of Tokyo",
    shortName: "THEUNIVERSITYOFTOKYO",
    totalInstitutions: 64528,
    percentIncrease: 0,
  },
];

const Home = () => {
  const [tableData, setTableData] = useState(null);

  const [searchedValue, setSearchedValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const { entityType } = useParams();

  const {
    entityName,
    changeTotalPublications,
    changePercentIncrease,
    changeSelectedFilterBy,
  } = useContext(AppContext);

  const navigate = useNavigate();
  // const location = useLocation();
  const { get, set, setMultiple } = useCustomSearchParams();
  const axiosService = new AxiosService();

  const filterAgencies = (data, searchText) => {
    if (!searchText) return data;

    const query = searchText?.toLowerCase();

    return data.filter(
      (item) =>
        item.funderName?.toLowerCase().includes(query) ||
        item.publisherName?.toLowerCase().includes(query) ||
        item.institutionName?.toLowerCase().includes(query) ||
        item.shortName?.toLowerCase().includes(query),
    );
  };

  const handleSearch = (searchValue) => {
    setSearchedValue(searchValue);
  };

  const handleRowClick = (row) => {
    changeTotalPublications(row.totalPublications);
    changePercentIncrease(row.percentIncrease);

    // set(
    //   SEARCH_PARAMS.ENTITY_NAME,
    //   row.funderName || row.publisherName || row.institytionName,
    // );
    setMultiple({
      [SEARCH_PARAMS.ENTITY_NAME]:
        row.funderName || row.publisherName || row.institutionName,
      [SEARCH_PARAMS.SHORT_NAME]: row.shortName,
      [SEARCH_PARAMS.ENTITY_ID]:
        row.memberId || row.agencyId || row.institutionId,
    });

    navigate(
      {
        pathname: `/${entityName}/publication-analytics`,
        search: window.location.search,
      },
      {
        state: {
          funderName: row.funderName, //: row.name,
        },
      },
    );
  };

  const handleSort = (order, field) => {
    // setSort({
    //   field: field,
    //   order: order,
    // });
    // !isModal && dispatch(setCurrentPage(1));
  };

  useEffect(() => {
    if (entityName !== entityType) return;

    changeSelectedFilterBy("ALL");
    setIsLoading(true);

    switch (entityName) {
      case KEY_NAME.FUNDER:
        // setTableData(() => {
        //   return {
        //     config: TABLE_CONFIG_FOR_FUNDER,
        //     data: TABLE_DATA_FOR_FUNDER,
        //   };
        // });

        axiosService
          .getFundersList()
          .then((response) => {
            setTableData(response.data);
          })
          .catch((error) => {
            console.error("Error:", error);
          })
          .finally(() => {
            setIsLoading(false);
          });

        break;
      case KEY_NAME.PUBLISHER:
        // setTableData(() => {
        //   return {
        //     config: TABLE_CONFIG_FOR_PUBLISHER,
        //     data: TABLE_DATA_FOR_PUBLISHER,
        //   };
        // });

        axiosService
          .getPublishersList()
          .then((response) => {
            setTableData(response.data);
          })
          .catch((error) => {
            console.error("Error:", error);
          })
          .finally(() => {
            setIsLoading(false);
          });
        break;
      case KEY_NAME.INSTITUTION:
        // setTableData(() => {
        //   return {
        //     config: TABLE_CONFIG_FOR_INSTITUTION,
        //     data: TABLE_DATA_FOR_INSTITUTION,
        //   };
        // });

        axiosService
          .getInstitutionsList()
          .then((response) => {
            setTableData(response.data);
          })
          .catch((error) => {
            console.error("Error:", error);
          })
          .finally(() => {
            setIsLoading(false);
          });
        break;

      default:
        break;
    }
  }, [entityName]);

  return (
    <div className="d-flex flex-column">
      <div className="container">
        <div className="d-flex flex-column align-items-start my-4 text-start">
          {entityName && (
            <h3 className="text-capitalize mb-3 ">{`${entityName} Dashboard Selection`}</h3>
          )}

          <p className="home-description">{HomeDescription(entityName)}</p>
        </div>

        {/* Search */}
        <div className="mb-4">
          <SearchInput
            placeholder={`Search for a ${entityName}`}
            onChange={(value) => handleSearch(value)}
            onSearch={() => {}}
          />
        </div>
        <hr className="mb-4" />
        {isLoading && <Loader />}

        {!isLoading && (
          <TableDetails
            // tableData={TABLE_DATA_FOR_FUNDER}
            // headers={TABLE_CONFIG_FOR_FUNDER}
            tableData={
              filterAgencies(tableData?.data, searchedValue) || tableData?.data
            }
            headers={tableData?.config}
            headerClassification={false}
            showPagination={false}
            start={0}
            handleSort={handleSort}
            sort={{
              field: "",
              order: "desc",
            }}
            onRowClick={handleRowClick}
            customClassName={"fit-cell"}
          />
        )}
      </div>
      <div className=" my-5 mx-auto">
        <ImageContainer />
      </div>
    </div>
  );
};

export default Home;
